import React from 'react';
import { SectionListQuestionListItem } from './SectionListQuestionListItem';
import { SectionListSectionListItem } from './SectionListSectionListItem';

type Props = {
  type: 'folder' | 'section' | 'question';
  id: number;
  level: number;
};

export const SectionListItem: React.FC<Props> = React.memo(
  ({ type, id, level }) => {
    if (type === 'question') {
      return <SectionListQuestionListItem id={id} level={level} />;
    }
    return <SectionListSectionListItem id={id} />;
  },
);
